export interface ILayoutModel {
  analytic: {
    sendEvent: (eventName: string, data: Record<string, any>) => void
  }
  eventBus: {
    dispatchEvent: (event: Event) => void
  }
}

export const layoutModel: ILayoutModel = {
  analytic: {
    sendEvent: (eventName, params, immediatelySent = false) => {
      const eventQueue = []
      eventQueue.push({ EventName: eventName, EventParams: params })

      if (immediatelySent) {
        eventQueue.length = 0
      }
    },
  },

  eventBus: {
    dispatchEvent: (event) => {
      document.dispatchEvent(event)
    },
  },
}
